// マスタ区分(工事型区分 / 材料区分)のフィルタ値をモジュールレベルで保持する。
// 「材料マスタ」「工事マスタ」「マスタ区分」のいずれかでフィルタを切り替えると、
// 他のマスタを開いた時も選択を維持する。
import { useEffect, useState } from "react";

type PartitionKey = "area_division_id" | "material_division_id";

const cache: Record<PartitionKey, number | null> = {
  area_division_id: null,
  material_division_id: null,
};
const subscribers = new Set<() => void>();

export function getPartitionFilter(key: PartitionKey): number | null {
  return cache[key];
}

export function setPartitionFilter(key: PartitionKey, value: number | null) {
  if (cache[key] === value) {
    return;
  }
  cache[key] = value;
  subscribers.forEach((fn) => fn());
}

export function usePartitionFilter(key: PartitionKey): [number | null, (v: number | null) => void] {
  const [, force] = useState(0);
  useEffect(() => {
    const fn = () => force((n) => n + 1);
    subscribers.add(fn);
    return () => {
      subscribers.delete(fn);
    };
  }, []);
  return [cache[key], (v) => setPartitionFilter(key, v)];
}
